import api from './api';

/**
 * Bug Report API endpoints
 * For beta testing feedback collection
 */

/**
 * Submit a bug report
 * @param {object} reportData - The bug report data
 * @param {string} reportData.category - 'bug' | 'suggestion' | 'confusion'
 * @param {string} reportData.severity - 'critical' | 'medium' | 'low'
 * @param {string} reportData.description - User description
 * @param {string} reportData.url - Current URL
 * @param {number|null} reportData.game_id - Game ID if in a game
 * @param {object|null} reportData.game_state - Current game state
 * @param {Array|null} reportData.console_logs - Captured console logs
 * @param {string|null} reportData.screenshot - Base64 encoded screenshot
 * @param {object|null} reportData.metadata - Browser/system info
 * @returns {Promise<object>} Response data
 */
export const submitBugReportApi = async (reportData) => {
    const response = await api.post('/api/bug-reports', reportData);
    return response.data;
};

/**
 * Get all bug reports (admin)
 * @returns {Promise<object>} Paginated bug reports
 */
export const getBugReportsApi = async () => {
    const response = await api.get('/api/bug-reports');
    return response.data;
};

/**
 * Get single bug report (admin)
 * @param {number} reportId - Bug report ID
 * @returns {Promise<object>} Bug report details
 */
export const getBugReportApi = async (reportId) => {
    const response = await api.get(`/api/bug-reports/${reportId}`);
    return response.data;
};

export default {
    submitBugReportApi,
    getBugReportsApi,
    getBugReportApi
};
